export * from './deviceConfig1'
export * from './deviceConfig2'
export * from './deviceConfig3'
export * from './deviceConfig4'
export * from './deviceConfig5'
export * from './scheduledReading'
export * from './sensorConfig1'
export * from './seqNumTimestamp'
export * from './testMessage'

import { SigFoxMessageType } from '../common/constants'
import { decodeDeviceConfig1 } from './deviceConfig1'
import { decodeDeviceConfig2 } from './deviceConfig2'
import { decodeDeviceConfig3 } from './deviceConfig3'
import { decodeDeviceConfig4 } from './deviceConfig4'
import { decodeDeviceConfig5 } from './deviceConfig5'
import { decodeTestMessage } from './testMessage'
import { decodeSchdMessage } from './scheduledReading'
import { decodeSensorConfig1 } from './sensorConfig1'
import { decodeSntsMessage } from './seqNumTimestamp'

import { hexStringToArrayBuffer } from '../common/utils'

export function parseMessage(messageContent: string) {
  return decode(hexStringToArrayBuffer(messageContent))
}

export function decode(data: Uint8Array) {
  const fnMap: { [key: number]: (data: Uint8Array) => any } = {
    [SigFoxMessageType.TestMessage]: decodeTestMessage,
    [SigFoxMessageType.SNTS]: decodeSntsMessage,
    [SigFoxMessageType.SCHD]: decodeSchdMessage,
    [SigFoxMessageType.DeviceConfig1]: decodeDeviceConfig1,
    [SigFoxMessageType.DeviceConfig2]: decodeDeviceConfig2,
    [SigFoxMessageType.DeviceConfig3]: decodeDeviceConfig3,
    [SigFoxMessageType.DeviceConfig4]: decodeDeviceConfig4,
    [SigFoxMessageType.DeviceConfig5]: decodeDeviceConfig5,
    [SigFoxMessageType.SensorConfig1]: decodeSensorConfig1,
  }

  // return fnMap[data[0]](data.slice(1))
  // const fn = fnMap[data[0]]

  // if (fn) {
  //   const result = fn(data.slice(1))
  //   console.log('*************', result)
  //   return result
  //   // (fn(data.slice(1)))
  // }
  return fnMap[data[0]](data.slice(1))
}

export function getMessageType(byte: number): SigFoxMessageType {
  // SigFoxMessageType

  return SigFoxMessageType.Unknown
}
